import { Link } from "react-router-dom";
import logo from "../../assets/logos/svg/Garejelebi Logo variations-12-10.svg";
import PrimaryButton from "../../UI/PrimaryButton";

export const TrainingCard = ({ course }) => {
  const formatDuration = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
      2,
      "0"
    )}:${String(secs).padStart(2, "0")}`;
  };
  return (
    <div className="flex flex-col justify-between items-center bg-gray-200 rounded-lg p-6 w-72 shadow-sm hover:shadow-md transition-shadow duration-300 border border-gray-100">
      {/* Logo Container */}
      <div className="flex items-center justify-center bg-gray-100 rounded-full w-16 h-16 mb-4 overflow-hidden">
        <img src={logo} alt="logo" className="h-20" />
      </div>

      {/* Course Details */}
      <div className="flex flex-col gap-3 flex-1 text-center">
        <h2 className="text-xl font-semibold text-baseBlue">{course.title}</h2>
        <p className="text-baseBlue text-sm">{course.description}</p>
        <p className="text-baseBlue text-sm">
          Duration: {formatDuration(course.duration)}
        </p>
        <p className="text-baseBlue text-sm">Price: {`${course.price} $`}</p>
      </div>

      {/* Call-to-Action Button */}
      <Link to={`${course.id}`} className="w-full mt-4">
        <PrimaryButton text="GET STARTED" />
      </Link>
    </div>
  );
};
